import request from '@/utils/httpRequest'

export default class RouteService {
  queryRouteById(id) {
    return request({
      url: '/patrol/wuyePatrolRoute/queryById',
      method: 'get',
      params: { id: id }
    })
  }

  startFlow(params) {
    return request({
      url: '/patrol/wuyePatrolRoute/startFlow',
      method: 'post',
      data: params
    })
  }
}
